import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fm160_01: string;
  fm160_11: string;
  fm160_22: string;
  cust_name: string;
  fm160_80: string;
  fm160_90: number;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const m5m8Api = {
  // POST /api/m5m8/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/m5m8/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/m5m8/execute
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/m5m8/execute', { doc_nos: docNos });
    return res.data;
  },
};
